import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@/components/Button';
import { supportedLocales } from '@/data/locale';
import { getPreferredLocale, setPreferredLocale } from '@/utils/locale';

import {
  button,
  layout,
  selectOption,
  selectInput,
  textWrapper,
} from './styles.module.css';

class LocaleChange extends Component {
  constructor(props) {
    super();

    // We want to fallback to the geoLocale if user selected
    // locale isn't set, which isn't used in getPreferredLocale
    let locale;
    if (props.userSelectedLocale) {
      locale = props.userSelectedLocale;
    } else if (props.countryCode) {
      locale = props.countryCode;
    } else {
      locale = getPreferredLocale({
        userSelectedLocale: props.userSelectedLocale,
      });
    }

    this.state = {
      selectedValue: locale,
    };
  }

  onOptionChange = (newVal) => {
    this.setState({
      selectedValue: newVal,
    });
  };

  onConfirm = () => {
    if (this.state.selectedValue) {
      setPreferredLocale(this.state.selectedValue);
      if (__CLIENT__) {
        const newLocale = supportedLocales.find(
          (l) => l.iso2 === this.state.selectedValue,
        );
        if (newLocale) {
          window.location.href = `/${newLocale.slug}`;
        } else {
          window.location.reload();
        }
      }
    }
  };

  render() {
    return (
      <div className={layout}>
        <div className={textWrapper}>
          Switch region to see content that’s relevant to your location.
        </div>

        <div>
          <select
            className={selectInput}
            value={this.state.selectedValue}
            onChange={(e) => {
              this.onOptionChange(e.target.value);
            }}
          >
            {supportedLocales.map((el) => {
              return (
                <option key={el.iso2} className={selectOption} value={el.iso2}>
                  {el.labelLong}
                </option>
              );
            })}
          </select>

          <Button primary onClick={this.onConfirm} className={button}>
            Continue
          </Button>
        </div>
      </div>
    );
  }
}

LocaleChange.propTypes = {
  userSelectedLocale: PropTypes.string,
  countryCode: PropTypes.string,
};

LocaleChange.defaultProps = {
  userSelectedLocale: undefined,
  countryCode: undefined,
};

export default LocaleChange;
